/*
 * Copyright (c) 2021 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */
import {network} from '@/config';
const Dex = require('btsdex');

export default {
    namespaced: true,

    state: {
        nodes: [
            "wss://node.xbts.io/ws",
            "wss://cloud.xbts.io/ws",
            "wss://public.xbts.io/ws",
            "wss://btsws.roelandp.nl/ws",
            "wss://eu.nodes.bitshares.ws",
            "wss://api.dex.trading/",
            "wss://api.bts.mobi/ws",
            "ws://localhost:8090",
        ],
        status: false,
        currentNode: "wss://node.xbts.io/ws"
    },

    getters: {
        nodes: state => state.nodes,
        status: state => state.status,
        currentNode: state => state.currentNode,
    },

    mutations: {
        SET_NODES(state, payload) {
            state.nodes = payload;
        },
        SET_STATUS(state, payload) {
            state.status = payload;
        },
        SET_NODE(state, payload) {
            state.currentNode = payload;
            console.log('SET_NODE', state.currentNode)
        },
    },

    actions: {
        async setNode({commit}, value) {
            commit('SET_NODE', value)
        },
        async setNodes({commit}, value) {
            commit('SET_NODES', value)
        },
        async setStatus({commit}, value) {
            commit('SET_STATUS', value)
        },
        async connect({commit}, value = "wss://node.xbts.io/ws") {
            try {
                //await Dex.connect(value);
                commit('SET_NODE', value);
                await this.dispatch('app/init', value);
            } catch(e) {

            }
        },
    }
}
